/**
 * Cost Ledger API helper (GW-8067)
 *
 * GW-8630: this module previously fetched a mission's products via
 * `MissionsClient.getProducts()` (`GET /v1/missions/{missionId}/products`)
 * to locate and map a PROD-CORE-004 record (and a PROD-CORE-003 audit-trail
 * lookup) for a given run. That route was never implemented by
 * gw-missions-api (confirmed dead — see PACT.md), so the fetch/map path was
 * permanently unreachable and has been removed. `emptyCostLedgerProduct`
 * remains: it is the real, live fallback `missionRunResultsSlice.ts`
 * returns for PROD-CORE-004 today.
 */

import type { CostLedgerProduct } from '@gw/ui/types';

/**
 * Honest empty PROD-CORE-004 assembly — zero budget, zero spend, no charge
 * items. This is the correct representation of "no cost-ledger content
 * available yet", not a fabricated placeholder.
 */
export function emptyCostLedgerProduct(): CostLedgerProduct {
  return {
    product_id: 'PROD-CORE-004',
    token_budget: 0,
    remaining_balance: 0,
    grand_total_smart_tokens: 0,
    charge_items: [],
    rates: {},
    datasets_with_unknown_cost: [],
    total_smart_tokens_spent: 0,
    dataset_query_cost_tokens: 0,
    inference_cost_tokens: 0,
    inference_cost_by_model: {},
    drawn_amount: 0,
    released_amount: 0,
  };
}
